// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trade-mark-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.trade-mark-icon{
  display: none;
  position: absolute;
  top: 15px;
  z-index: 3;
  left: 15px;
}
.trade-mark {
  position: fixed;
  z-index: 1 !important;
  bottom: 20px;
  /* left: 50px; */
  right:75px;
}
@media (max-width: 420px) {
  /* .trade-mark-img {
    width: 100px;
    height: 19px;
    object-fit: contain;
  } */

  .trade-mark-icon{
    display: block;
  }

  .trade-mark {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 60px;
  }
}
@media only screen and (min-width: 421px) and (max-width: 740px) {
  /* .trade-mark-img {
    width: 80px;
    height: 25px;
    object-fit: contain;
  } */

  .trade-mark {
    position: fixed;
    bottom: 18px;
    right: 73px;
  }
}
@media only screen and (min-width: 741px) and (max-width: 770px) {
  /* .trade-mark-img {
    width: 84px;
    height: 30px;
    object-fit: contain;
  } */

  .trade-mark {
    position: fixed;
    bottom: 15px;
    right: 72px;
  }
}
@media only screen and (min-width: 771px) and (max-width: 950px) {
  /* .trade-mark-img {
    width: 120px;
    height: 24px;
    object-fit: contain;
  } */

  .trade-mark {
    position: fixed;
    bottom: 20px;
    right: 60px;
  }
}
@media only screen and (min-width: 951px) and (max-width: 1258px) {
  /* .trade-mark-img {
    width: 130px;
    height: 28px;
    object-fit: contain;
  } */

  .trade-mark {
    position: fixed;
    bottom: 20px;
    right: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/ui/TradeMark/trademark.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE;;;;KAIG;;EAEH;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;;;;KAIG;;EAEH;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;;;;KAIG;;EAEH;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;;;;KAIG;;EAEH;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;;;;KAIG;;EAEH;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".trade-mark-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.trade-mark-icon{\n  display: none;\n  position: absolute;\n  top: 15px;\n  z-index: 3;\n  left: 15px;\n}\n.trade-mark {\n  position: fixed;\n  z-index: 1 !important;\n  bottom: 20px;\n  /* left: 50px; */\n  right:75px;\n}\n@media (max-width: 420px) {\n  /* .trade-mark-img {\n    width: 100px;\n    height: 19px;\n    object-fit: contain;\n  } */\n\n  .trade-mark-icon{\n    display: block;\n  }\n\n  .trade-mark {\n    display: none;\n    position: fixed;\n    bottom: 20px;\n    right: 60px;\n  }\n}\n@media only screen and (min-width: 421px) and (max-width: 740px) {\n  /* .trade-mark-img {\n    width: 80px;\n    height: 25px;\n    object-fit: contain;\n  } */\n\n  .trade-mark {\n    position: fixed;\n    bottom: 18px;\n    right: 73px;\n  }\n}\n@media only screen and (min-width: 741px) and (max-width: 770px) {\n  /* .trade-mark-img {\n    width: 84px;\n    height: 30px;\n    object-fit: contain;\n  } */\n\n  .trade-mark {\n    position: fixed;\n    bottom: 15px;\n    right: 72px;\n  }\n}\n@media only screen and (min-width: 771px) and (max-width: 950px) {\n  /* .trade-mark-img {\n    width: 120px;\n    height: 24px;\n    object-fit: contain;\n  } */\n\n  .trade-mark {\n    position: fixed;\n    bottom: 20px;\n    right: 60px;\n  }\n}\n@media only screen and (min-width: 951px) and (max-width: 1258px) {\n  /* .trade-mark-img {\n    width: 130px;\n    height: 28px;\n    object-fit: contain;\n  } */\n\n  .trade-mark {\n    position: fixed;\n    bottom: 20px;\n    right: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
